import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import styled from 'styled-components';
import Button from "./Button";
import BALogo from "./BALogo";
import ProsCons from "./ProsCons";
import OpinionText from "./OpinionText";
import ReactMarkdown  from "react-markdown";
import TableOfContent from "./TableOfContent";
import {
    ApplePay,
    PaySafe,
    Neteller,
    Paypal,
    Visa,
    MasterCard,
    Trustly,
    FastBank,
    BankTransfer,
    CheckPay,
    NeoSurf,
    Skrill,
    DefaultLogo
} from "./PaymentLogo";

import './componentsStyle/OpinionesWidget.css';

const Grid = styled.div`
    display:grid;
    grid-template-columns: 1fr;
    grid-column-gap: 1rem;

    @media (max-width: 600px) {
       grid-template-columns: 1fr;
    }
`;

const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-auto-flow: column;
    background-color: #E5E5E5;
    padding: 25px 40px 35px 45px;

    @media screen and (max-width: 770px) {
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-flow: row;
    }
`;

const BonosGridWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    justify-content: left;
    margin-top: 2px;

    @media screen and (max-width: 770px) {
        justify-content: center;
    }
`;
const BonosBodyGridWrapper = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 3fr 1fr;
    justify-content: left;
    grid-column-gap: 20px;
    margin-top: 20px;

    @media screen and (max-width: 770px) {
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-flow: row;
    }
`;

const validPaymentLogos = {
    "applepay": ApplePay,
    "paysafe": PaySafe,
    "neteller": Neteller,
    "paypal": Paypal,
    "visa": Visa,
    "mastercard": MasterCard,
    "trustly": Trustly,
    "fastbank": FastBank,
    "banktransfer": BankTransfer,
    "checkpay": CheckPay,
    "neosurf": NeoSurf,
    "skrill": Skrill,
    "defaultlogo": DefaultLogo
};

const PaymentLogo = props => {
    let TagName = DefaultLogo;
    if (props.name !== undefined) {
        const logoName = props.name.replace(/\s/g, '').toLowerCase();

        if (typeof validPaymentLogos[logoName] !== undefined) {
            TagName = validPaymentLogos[logoName];
        }
    }

    return (
        <TagName className="logo-payments" name={props.name} customClassName={props.customClassName} />
    );
};

const OpinionSiteWidget = ({ opinion, ...rest }) => {

    var htmlCollection = document.getElementsByClassName('linkable-section');


    const [contentLinks, setcontentLinks] = useState([
        { id: "opinion-intro", textContent: "Introducción" },
        { id: "opinion-proscons", textContent: "Pros y Cons" },
        ...htmlCollection
    ]); 

    const bonoDeCasinoLabel = "Bono de Casino " + opinion.bonoCasino + "€";
    const bonoDeSportsLabel = "Bono de 100% hasta " + opinion.bonoEuros + "€";
    const imgClassName = "opiniones-header-img header-img-" + opinion.name.toLowerCase();

    return (
        <Grid {...rest}>
            <Helmet>
                <meta name="description" content={opinion.metaDescription} />
                <title>{opinion.metaTitle}</title>
            </Helmet>
            <div className="opinines-main-div bring-content-forward object-card no-margin">      
                <GridWrapper>
                    <div className="opiniones-header">

                        <BonosGridWrapper>
                            <div class="opiniones-title title-text home-title">{opinion.name}</div>
                                {/* TODO - TRANSFORM INTO COMPONENT*/}
                                <div className="rating-opiniones__numb rating-opiniones__pos">
                                <div className="rating-opiniones__numb__svg rating-opiniones__numb__svg__margin">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24" width="40">
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 
                                15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/>
                                        </svg>
                                    </ div>

                                    <div className="rating-opiniones__numb__val rating-opiniones__numb__size">
                                        {opinion.rating}
                                    </ div>
                                </ div>
                        </ BonosGridWrapper>                        
           
                        <div className="dashed-white-border btn-bonos__size">
                            <Button className="btn-bonos__margin" url={opinion.bonoUrlCasino} label={bonoDeCasinoLabel} target="blank" />
                        </ div>

                        <div className="dashed-white-border btn-bonos__size">
                            <Button className="btn-bonos__margin__b" url={opinion.bonoUrl} label={bonoDeSportsLabel} target="blank" />
                        </ div>

                        <div className="payment-methods payment-methods-margin">
                            {opinion.deposit.map(pc => (
                                <PaymentLogo className="payment-logo-opiniones" name={pc} customClassName={"payment-logo-tag-" + pc} />
                            ))}
                        </div>
                    </div> 

                    <div className={imgClassName}>
                        <img src={require(`../../public/assets/images/${opinion.imageUrl}`)} />
                    </div>
                </GridWrapper>
            </div>
            <div className="space-holder bring-content-forward">
                <BonosBodyGridWrapper>
                    <div className="card opinion-body object-card card-order-op">
                        <div className="opinion-body-intro">
                            <div id="opinion-intro" className="opinion-card-title title-text opinion-title-space">
                                Introducción
                            </div>
                            <ReactMarkdown source={opinion.intoduction} escapeHtml={false} />
                        </div>
                        <div className="opinion-body-proscons">
                            <div id="opinion-proscons"  className="opinion-card-title title-tex opinion-title-space">
                                Ventajas y Desventajas
                            </div>
                            {opinion.prosandCons.map(pc => (
                                <ProsCons
                                type={pc.type}
                                comment={pc.comment}
                                />
                            ))}
                        </div>
                        <OpinionText setStateContentLinks={setcontentLinks} opinion={opinion.opinion} />
                    </div>
                    <div className="card-order-op">
                        <TableOfContent contentLinks={contentLinks}/>
   
                        <div className="card opinion-card__spacing object-card">
                            <div className="opinion-card-title title-text">
                                Atencion al Cliente
                            </div>
                            <div className="opinion-card-body customer-service-grid">
                                <div className="ac-phone-number-label">
                                    Telefono:
                                </div>
                                <div className="ac-phone-number-val">
                                    {opinion.contact.phoneNumber}
                                </div>
                                <div className="ac-email-label">
                                    E-mail:
                                </div>
                                <div className="ac-email-val">
                                    {opinion.contact.email}
                                </div>
                                <div className="ac-chat-label">
                                    Online Chat:
                                </div>
                                <div className="ac-chat-val">
                                    {
                                        !opinion.contact.chat ?
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#CC1D10" width="24px" height="24px">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            </svg>
                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0BD926" width="24px" height="24px">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                            </svg>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="card opinion-card__spacing object-card">                            
                            <div className="opinion-card-title title-text">
                                Depositos
                            </div>
                            <div className="opinion-card-body opinion-payment-grid">
                                {opinion.deposit.map(pc => (
                                    <PaymentLogo className="payment-logo-opiniones" name={pc} customClassName={"payment-logo-tag-" + pc} />
                                ))}
                            </div>
                        </div>
                        <div className="card opinion-card__spacing object-card">                            
                            <div className="opinion-card-title title-text">
                                Ingresos
                            </div>
                            <div className="opinion-card-body opinion-payment-grid">
                                {opinion.withdraw.map(pc => (
                                    <PaymentLogo className="payment-logo-opiniones" name={pc} customClassName={"payment-logo-tag-" + pc} />
                                ))}
                            </div>
                        </div>
                    </div>
                </ BonosBodyGridWrapper>

                <div className="opinion-btn__pos">
                    <div>
                    </div>
                    <Button className="btn-bonos__margin btn-bonos__margin__mb" url={opinion.bonoUrl} label="Jugar Ahora" target="blank" />
                    <div>
                    </div>
                </div>
            </div>

            <div className="bg-circle bg-circle-pos">
                <BALogo height={"60%"} width={"60%"} primaryColor={"#FFFFFF"} />
            </div>   
        </Grid >
    );
}

export default OpinionSiteWidget;
